var map = {
	"./add.svg": 5873,
	"./attach.svg": 1085,
	"./bin.svg": 928,
	"./check-bold.svg": 6324,
	"./chevron-down.svg": 4854,
	"./chevron-left.svg": 7328,
	"./chevron-right.svg": 3649,
	"./chevron-up.svg": 8693,
	"./close.svg": 5744,
	"./collapse.svg": 150,
	"./customer.svg": 6749,
	"./dashboard.svg": 3724,
	"./delete-filled.svg": 123,
	"./delete.svg": 2065,
	"./done.svg": 7901,
	"./dots.svg": 4707,
	"./double-left.svg": 3804,
	"./double-right.svg": 9531,
	"./download.svg": 8122,
	"./drag-and-drop.svg": 7105,
	"./duplicate.svg": 7159,
	"./error.svg": 9429,
	"./eye.svg": 7764,
	"./info.svg": 4670,
	"./left.svg": 8911,
	"./loading.svg": 4395,
	"./menus.svg": 2560,
	"./min.svg": 113,
	"./minus.svg": 111,
	"./pages.svg": 1411,
	"./pencil-filled.svg": 4036,
	"./person.svg": 860,
	"./plus.svg": 3000,
	"./profile.svg": 9481,
	"./right.svg": 183,
	"./search.svg": 2322,
	"./settings.svg": 2707,
	"./sign-out.svg": 9346,
	"./tags.svg": 1288,
	"./users.svg": 9733,
	"./videos.svg": 2524,
	"./warning.svg": 7141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6465;